import $ from "jquery";

$(function () {
    // Hidden refresh links
    let refreshVariant = function () {
        $('.refresh-variant-link').each(function () {
            let tr = $(this).closest('tr')
            let href = $(this).data('path')

            $.getJSON(href, function (data, status, xhr) {
                if (data.variant) {
                    // Update variant
                    let newTr = $(data.variant)
                    tr.replaceWith(newTr)
                    // Trigger logo processing check after row update
                    // The new row should already have the correct data-image_status
                    // but we refresh to be sure
                    if (typeof refreshLogoProcessingState === 'function') {
                        refreshLogoProcessingState()
                    }
                } else {
                    // Remove variant if it has been deleted
                    tr.remove()
                }
            })
        })

        if ($('.refresh-variant-link').length > 0) {
            window.setTimeout(refreshVariant, 30000)
        }
    }

    window.setTimeout(refreshVariant, 10000)
})
